import { render } from "./feedInquire.vue?vue&type=template&id=afd68c7e&scoped=true"
import script from "./feedInquire.vue?vue&type=script&lang=js"
export * from "./feedInquire.vue?vue&type=script&lang=js"

import "./feedInquire.vue?vue&type=style&index=0&id=afd68c7e&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd68c7e"]])

export default __exports__